import React, { useState, useContext } from "react";
import { PageLayout } from "../components/page-layout";
import { LeaderboardContext } from "../contexts/leaderboard-context";
import { SiteVarsContext } from "../contexts/sitevars-context";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Fade } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import LeaderboardTeamDialogue from "../components/leaderboard-team-dialogue";
import { LeaderboardStatusPanel } from "../components/leaderboard-status-panel";

export const LeaderboardPage = () => {
  const {leaderboardData} = useContext(LeaderboardContext);
  const [isTeamDialogueOpen, setTeamDialogueIsOpen] = useState(false);
  const [selectedTeamData, setSelectedTeamData] = useState({});
  const {siteVarsData} = useContext(SiteVarsContext);
  const [currentWindowValue] = useState(siteVarsData.game_vars.currentWindow);

  return (
    <PageLayout>
      <LeaderboardTeamDialogue open={isTeamDialogueOpen} teamData={selectedTeamData} key={selectedTeamData.clubName} handleCloseTeamDialogue={setTeamDialogueIsOpen}/>
      <TableContainer component={Paper}>
      {leaderboardData.length === 0 && (
        <Fade in={true} timeout={1000}>
          <Stack spacing={0.5}>
            <Skeleton variant="rounded" width={"100%"} height={30} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
            <Skeleton variant="rounded" width={"100%"} height={45} />
          </Stack>
        </Fade>
      )}
      {leaderboardData.length > 0 && (
      <Table sx={{ minWidth: 350 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ minWidth: 50, paddingLeft:0, paddingRight: 0 }}></TableCell>
            <TableCell style={{ width: 10, padding: "6px 10px" }}></TableCell>
            <TableCell style={{ minWidth: 189, paddingLeft: 0, paddingRight: 0 }}>Club</TableCell>
            <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Week</TableCell>
            <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaderboardData.map((row, index) => (
            <TableRow
              key={row.managerName}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              hover
              onClick={() => {setSelectedTeamData(row); setTeamDialogueIsOpen(true)}}
            >
              <TableCell scope="row" style={{ paddingLeft: 5, paddingRight: 0, paddingBottom:0 }}>
                <img src={'/static/img/club-logos/120x120/'+row.clubId+'.png'} alt={row.clubName} style={{ width: '50px', height: '50px' }} />
              </TableCell>
              <TableCell style={{ width: 10, padding: "6px 10px", textAlign: "center", lineHeight: 0.5, paddingTop: (index + 1 !== row.prevPosition) ? 16 : 6 }}>
                {index + 1}
                {index + 1 < row.prevPosition && <ArrowDropUpIcon style={{ color: 'green'}} />}
                {index + 1 > row.prevPosition && <ArrowDropDownIcon style={{ color: 'red'}} />}
              </TableCell>
              <TableCell component="th" scope="row" style={{ paddingLeft: 0, paddingRight: 0}}>
                <span>{row.clubName}</span>
                <br />
                {row.managerName}
              </TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{row.weekScore}</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{row.totalScore}
                {currentWindowValue > 1 && (
                  <>
                    <br />
                    <span style={{fontSize:"8pt", color:"#999"}}>{row.windowScore + row.weekScore}</span>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      )}
    </TableContainer>
    <LeaderboardStatusPanel />
    </PageLayout>
  );
};
